import React, { useState, useEffect, useCallback } from 'react';
import { format, parseISO } from 'date-fns';
import { Form } from '@unform/web';

import api from '../../services/api';

import Input from 'components/Input';
import Button from 'components/Button';
import Loader from 'components/ContentLoader/ItemImportListLoader';
import { toast } from 'react-toastify';

import { FiSearch, FiDownloadCloud } from 'react-icons/fi';

import { Container, Item } from './styles';

import { Scroll } from '../../styles/global';

function Import({ handleImport }) {
  const [loading, setLoading] = useState(false);
  const [legendas, setLegendas] = useState([]);

  const handleSearch = useCallback(async ({ search }) => {
    if (search) {
      setLoading(true);
      try {
        const response = await api.get('legendas', {
          params: { retranca: search },
        });
        setLoading(false);
        setLegendas(
          response.data.docs.map(data => ({
            id: data.id,
            retranca: data.retranca,
            status: data.status,
            data: `Ultima alteração em: ${format(
              parseISO(data.updated_at),
              'dd/MM/yyyy HH:ii',
            )}`,

            legendas: data.midia.legenda,
          })),
        );
      } catch (err) {
        setLoading(false);
        console.log(err);
        toast.error('erro ao buscar a legenda');
      }
    }
  }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await api.get('legendas', {
          params: { retranca: '' },
        });
        setLoading(false);
        setLegendas(
          response.data.docs.map(data => ({
            id: data.id,
            retranca: data.retranca,
            status: data.status,
            data: `Ultima alteração em: ${format(
              parseISO(data.updated_at),
              'dd/MM/yyyy HH:ii',
            )}`,

            legendas: data.midia.legenda,
          })),
        );
      } catch (err) {
        setLoading(false);
        console.log(err);
        toast.error('erro ao buscar a legenda');
      }
    })();
  }, []);

  return (
    <Container>
      <Form onSubmit={handleSearch}>
        <Input name="search" placeholder="Digite uma retranca aqui" />
        <Button
          color="primary"
          size="sm"
          onClick={handleSearch}
          tooltip="Buscar"
        >
          <FiSearch />
        </Button>
      </Form>
      <Scroll padding="15px 0 0 " height="300px">
        {loading ? (
          <Loader />
        ) : !!legendas && legendas.length > 0 ? (
          legendas.map(le => (
            <Item
              key={le.id}
              status={le.status}
              onClick={() => handleImport(le)}
            >
              <span />
              <div>
                <p>{le.retranca}</p>
                <strong>{le.data}</strong>
              </div>
              <FiDownloadCloud />
            </Item>
          ))
        ) : (
          <p>Nenhuma retranca localizada</p>
        )}
      </Scroll>
    </Container>
  );
}

export default Import;
